// extracted by mini-css-extract-plugin
module.exports = {"link":"FileFormalTable_link__aUtOM"};